"use strict";

exports.__esModule = true;
exports.default = void 0;

var millisecondsToDuration = function millisecondsToDuration(milliseconds) {
  var date = new Date(milliseconds);
  var hours = date.getUTCHours();
  var minutes = date.getUTCMinutes();
  return {
    hours: hours,
    minutes: minutes
  };
};

var _default = millisecondsToDuration;
exports.default = _default;